"use client";

import React from "react";

const Listing = ({ attributes }) => {
  return (
    <div className="listing-wrapper">
      <div className="listing">
        {(attributes?.listings || []).map((item) => (
          <div key={item.id} className="jlt-border jlt-border-border jlt-rounded-[6px] jlt-p-5">
            <h3 className="jlt-text-xl jlt-text-[#475467] !jlt-m-0">{item.name}</h3>
            <p className="jlt-text-base jlt-text-[#475467] jlt-mt-3">{item.description}</p>

            <div className="jlt-flex jlt-flex-col jlt-gap-2 jlt-mt-6 jlt-text-[#475467]">
              <div className="jlt-border jlt-border-border jlt-rounded-md jlt-font-medium jlt-py-1.5 jlt-px-3 jlt-w-full">
                <strong>{item.deal_info}</strong>
              </div>
              <div className="jlt-border jlt-border-border jlt-rounded-md jlt-font-medium jlt-py-1.5 jlt-px-3 jlt-w-full">
                {item.validity}
              </div>
              <div className="jlt-border jlt-border-border jlt-rounded-md jlt-font-medium jlt-py-1.5 jlt-px-3 jlt-w-full">
                {item.coupon_code}
              </div>

              <div className="jlt-flex jlt-items-center jlt-justify-center jlt-mt-4">
                <a
                  href={item.button_settings.url}
                  target={item.button_settings.blank ? "_blank" : "_self"}
                  className="jlt-border jlt-border-border jlt-bg-white jlt-rounded-full jlt-py-3 jlt-px-6 jlt-shadow-[0_4px_4px_0_#1717170A] jlt-font-semibold hover:jlt-bg-[--primary] hover:jlt-text-white jlt-transition-all jlt-duration-150 jlt-button"
                >
                  {item.button_text}
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .listing-wrapper {
          container-name: listingContainer;
          container-type: inline-size;
        }

        .listing {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 24px;
        }

        @container listingContainer (width < 600px) {
          .listing {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default Listing;
